<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title"><img :src="require('@/assets/images/ewide-logo.png')" style="width:190px;"/></h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">

      <el-row :gutter="10">
      <el-col :span="24" class="mt-2">
        <div class="text-center" v-html="text"></div>
      </el-col>
      </el-row>


      </div>
      <div class="modal-footer">
            <el-button @click="$emit('dismiss')">닫 기</el-button>
            <el-button v-if="fileName" @click="download">첨부파일 다운로드</el-button>
      </div>
    </div>

</template>

<script>


export default {
    created() {
    },
    props: {
        text: String,
        fileName: String,
        roleCode: String
    },
    data() {
      return {
      }
    },    
    methods: {
      download() {
        location.href = "/api/settings/info/" + this.roleCode + "/download?authorization=" + $cookies.get('id_token');
      }
    },

}
</script>